import React from "react";
import Seo from "../../components/seo";
import { Link } from "gatsby";
import Logos from "../../components/layout/Logos";
import useIsInViewport from "../../hooks/useIsInViewport";
// import Tooltip from '../plugins/Tooltip';

/* START: images import */
import magnus_art_logo from "../../img/services/magnus_art_logo.svg";
import elmwood from "../../img/services/elmwood.svg";
//import zpevnik from "../../img/services/zpevnik.svg";
import mouse_app from "../../img/services/mouse_app.svg";
import kohinoor from "../../img/services/kohinoor.svg";
//import project_royal_mail from "../../img/services/project_royal_mail.svg";
//import project_mondelez from "../../img/services/project_mondelez.svg";
import joalis_logo from "../../img/services/logo-joalis.png";
import mpm from "../../img/services/mpm.svg";
import biocultus from "../../img/services/biocultus.svg";

import barrocal from "../../img/services/barrocal.svg";
import elements from "../../img/services/elements.svg";
import every_interaction from "../../img/services/every_interaction.png";
import plan_a from "../../img/services/plan-a.svg";
//import alpha from "../../img/services/alpha.svg";
import hgg from "../../img/services/hgg.svg";
import moonwood from "../../img/services/moonwood.gif";
import darley_anderson from "../../img/services/darley_anderson.svg";
import magic_works from "../../img/services/magic_works.svg";
import spell from "../../img/services/spell.svg";
//import furnatura from "../../img/services/furnatura.svg";
import yogarden from "../../img/services/yogarden.svg";

const Hospitality = ({ indx, setObserverRef }) => (
    <article className="article" id="hospitality" ref={setObserverRef} data-observer={indx}>
        <article>
            <h2 className="animate-3 h3">Pohostinství</h2>
            <div className="examples animate-4">
                <div>
                    <img className="animate-5" src={barrocal} style={{ margin: "28px", height: "78px" }} alt="São Lourenço do Barrocal" />
                    <h4 className="line project animate-6" style={{ color: "#af6824" }}>
                        São Lourenço do Barrocal
                    </h4>
                    <p className="animate-7">
                        Tento statek je v rukou jedné rodiny více než 200 let a jeho srdcem je „monte“ – starobylá malá zemědělská vesnice, která byla citlivě oživena a přeměněna v pozoruhodný hotel s nenápadným luxusem, obklopený starými duby cesmínovými, olivovníky a vinicemi.
                    </p>
                    <a className="animate-8" href="https://barrocal.pt" target="_blank" rel="noopener noreferrer">
                        Navštivte web
                    </a>
                </div>
                <div>
                    <img className="animate-5" src={elements} style={{ margin: "20px", maxWidth: "150px", marginTop: "10px" }} alt="Elements" />
                    <h4 className="line project animate-6" style={{ color: "#1d4940" }}>
                        Všechny prvky Tater
                    </h4>
                    <p className="animate-7">
                        Poznejte svůj druhý domov na horách. Náš příběh začíná na úpatí Lomnického štítu, v srdci krásné a divoké tatranské přírody. Přírody, která v nás svou velkolepostí vzbuzuje respekt, ale zároveň nás dokáže laskavě obejmout, utišit a přimět odložit starosti všedního dne.
                    </p>
                    <a className="animate-8" href="https://elementslomnica.sk" target="_blank" rel="noopener noreferrer">
                        Navštivte web
                    </a>
                </div>
            </div>
        </article>
    </article>
);

const Ecommerce = ({ indx, setObserverRef }) => (
    <article className="article" id="ecommerce" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">E-commerce</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={biocultus} style={{ margin: "70px 40px", maxWidth: "250px" }} alt="Biocultus" />
                <h4>Kompostovací toalety</h4>
                <p className="animate-7">
                    Řešení běží na míru vytvořené platformě Shop8 s <a href="https://nextjs.org/" target="_blank" rel="noopener noreferrer">Next.js</a> frontendem, nabízí vysokou rychlost, podporu různých jazyků, měn i zemí a poskytuje bezproblémový nákupní zážitek pro zákazníky z celého světa.
                </p>
                <a className="animate-8" href="https://www.biocultus.com" target="_blank" rel="noopener noreferrer">
                    Kupte si záchod
                </a>
            </div>
            <div>
                <img className="animate-5" src={kohinoor} style={{ margin: "20px", width: "150px" }} alt="Koh-i-noor" />
                <h4 className="line project animate-6">{/* Koh-i-noor Deutschland */}</h4>
                <p className="animate-7">
                    V roce 1790 položil dvorní architekt Joseph Hardtmuth základy společnosti, ze které jeho potomci – zejména syn Carl a vnuk Franz – vytvořili jeden z největších podniků na světě v tomto oboru. V roce 2024 přivádíme jejich portfolio na německý trh.
                </p>
                <a className="animate-8" href="https://www.kohinoordeutschland.de" target="_blank" rel="noopener noreferrer">
                    Je libo versatilku?
                </a>
            </div>
        </div>
    </article>
);

/*
const BrandAgencies = ({ indx, setObserverRef }) => (
    <article className="article" id="brandagencies" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">Brand & UX agentůry</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={elmwood} style={{ margin: "32px", width: "240px" }} alt="Elmwood" />
                <h4 className="line project animate-6">Animated presentation</h4>
                <p className="animate-7">
                    One of the best branding companies in the world let us build a snappy web site to cater for their global needs. The site utilizes all the superpowers of Gatsby
                    cloud.
                </p>
                <a className="animate-8" href="https://www.elmwood.com/" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
            <div>
                <img className="animate-5" src={every_interaction} style={{ margin: "45px", maxHeight: "70px" }} alt="Every Interaction" />
                <p className="animate-7">
                    You’ll be working iteratively and side-by-side with us to blend your deep domain knowledge with our specialist UX design expertise. We’ll champion the needs of
                    your users at every step, so that your business needs are met in turn.
                </p>
                <a className="animate-8" href="https://www.everyinteraction.com" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
        </div>
    </article>
);*/

const Collections = ({ indx, setObserverRef }) => (
    <article className="article" id="collections" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">Digitální kolekce</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={mpm} style={{ margin: "28px", height: "78px" }} alt="DrMouse" />
                <h4 className="line project animate-6">Online katalog</h4>
                <p className="animate-7">
                    Sbírka aktuálně obsahuje více než 2800 jednotlivých modelů od více než 250 různých značek. Celkový počet zařízení přesahuje 6000
                </p>
                <a className="animate-8" href="https://www.mobilephonemuseum.com" target="_blank" rel="noopener noreferrer">
                    Vraťte se do minulosti
                </a>
            </div>
            <div>
                <img className="animate-5" src={magnus_art_logo} style={{ margin: "25px", maxWidth: "300px" }} alt="MagnusArt" />
                <h4 className="line project animate-6">Unikátní portfolio web</h4>
                <p className="animate-7">
                    Klient si přál spravovat obsah webu přes svůj oblíbený CMS, ale bylo velmi pravděpodobné, že stránky nebudou aktualizované příliš často. To je ideální scénář
                    pro použití generátoru statických stránek, který by si pro data šahal do externí WordPress instance.
                </p>
                <a className="animate-8" href="https://magnusart.cz" target="_blank" rel="noopener noreferrer">
                    Kultůra za 500!
                </a>
            </div>
        </div>
    </article>
);

const MobileApps = ({ indx, setObserverRef }) => (
    <article className="article" id="mobileApps" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">Mobilní aplikace</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={spell} style={{ margin: "45px", maxHeight: "60px" }} alt="Spell" />
                <h4 className="line project animate-6">Přední české kadeřnictví</h4>
                <p className="animate-7">
                    Představení týmu, rezervace, plné portfolio kadeřnických produktů, správa vlastního účtu - vše na jednom místě.
                </p>
                <a className="animate-8" href="mailto:info@code8.cz">
                    Dozvědět se více
                </a>
            </div>
            <div>
                <img className="animate-5" src={mouse_app} style={{ margin: "20px 40px", width: "85px" }} alt="Dr Mouse App" />
                <h4 className="line project animate-6">Dr. Mouse</h4>
                <p className="animate-7">
                    Dr. Mouse je mobilní aplikace pro Android a iOS. Mapuje veterináře v Česku a pomáhá vám najít toho správného pro vašeho mazlíčka kdekoliv – i bez připojení k internetu. Praktické, zejména v případě nouze, nemyslíte?{" "}
                </p>
                <a className="animate-8" href="https://www.drmouse.cz/aplikace" target="_blank" rel="noopener noreferrer">
                    Stahujte zde
                </a>
            </div>
        </div>
    </article>
);

const Architects = ({ indx, setObserverRef }) => (
    <article className="article" id="architects" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">Architektonická studia</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={plan_a} style={{ margin: "40px", width: "150px" }} alt="Plan A" />
                <h4 className="line project animate-6">Plan A consultants</h4>
                <p className="animate-7">
                    Od roku 2015 podporujeme nejuznávanější architekty na světě specializovanými službami v oblasti řízení návrhů. Naše globální odborné znalosti napříč různými sektory zahrnují projekty všech typů a velikostí – od přelomového urbanistického designu přes kulturní instituce, sportovní stadiony, letiště, univerzity až po rekreační resorty.
                </p>
                <a className="animate-8" href="https://planaconsultants.com" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
            <div>
                <img className="animate-5" src={hgg} style={{ margin: "35px", maxWidth: "200px" }} alt="HGG London" />
                <h4 className="line project animate-6" style={{ color: "#004257" }}>
                    Butiková developerská společnost
                </h4>
                <p className="animate-7">
                    HGG London se zavazuje k uváženému rozvoji, který je v souladu s potřebami Londýna. Jejich projekty mají pozitivní dopad na město – posilují čtvrti a komunity a zároveň respektují životní prostředí.
                </p>
                <a className="animate-8" href="https://hgglondon.co.uk" target="_blank" rel="noopener noreferrer">
                    Zjistěte víc
                </a>
            </div>
            {/*             <div>
                <img className="animate-5" src={alpha} style={{ margin: "25px", minWidth: "200px" }} alt="Alpha works" />
                <h4 className="line project animate-6" style={{ color: "#003af1" }}>
                    Alpha Works
                </h4>
                <p className="animate-7">Alpha Works is a co-working workspace in Alpha, Birmingham’s iconic modernist tower.</p>
                <a className="animate-8" href="https://www.alphaworksb1.co.uk/" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div> */}
        </div>
    </article>
);

const Publishing = ({ indx, setObserverRef }) => (
    <article className="article" id="publishing" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">Publishing</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={moonwood} style={{ margin: "5px 0 20px", maxWidth: "200px" }} alt="Moonwood books" />
                <h4 className="line project animate-6">Moonwood</h4>
                <p className="animate-7">
                    Moonwood distribuuje anglické dětské knihy po celé Evropě, přímo školám a rodičům. Jde o rodinnou firmu se sídlem v Praze.
                    Založila ji v roce 2014 Zoë Jeremy a jejím posláním je inspirovat děti k celoživotní lásce ke čtení.
                </p>
                <a className="animate-8" href="https://www.moonwood-books.com" target="_blank" rel="noopener noreferrer">
                    Začtěte se
                </a>
            </div>
            <div>
                <img className="animate-5" src={darley_anderson} style={{ margin: "40px", width: "150px" }} alt="Darley Anderson" />
                <h4 className="line project animate-6">Darley Anderson</h4>
                <p className="animate-7">
                    Agentura Darley Anderson Agency & Associates se specializuje na komerční beletrii s potenciálem bestselleru. Jejich seznam zahrnuje thrillery, detektivky, napínavou literaturu, krimi, horory, přístupnou literární prózu, romanci, romantické fantasy, ságy a historické romány.
                </p>
                <a className="animate-8" href="https://darleyanderson.com" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div>
        </div>
    </article>
);

const ThereSMore = ({ indx, setObserverRef }) => (
    <article className="article" id="thersmore" ref={setObserverRef} data-observer={indx}>
        <h2 className="animate-3 h3">Je toho víc...</h2>
        <div className="examples animate-4">
            <div>
                <img className="animate-5" src={magic_works} style={{ margin: "40px", width: "150px" }} alt="Magic Works" />
                <h4 className="line project animate-6">Magic Works</h4>
                <p className="animate-7">Školení, které je praktické, naprosto aktuální a užitečné v reálném světě.</p>
                <a className="animate-8" href="https://magicworks.training" target="_blank" rel="noopener noreferrer">
                    Vyškolte se
                </a>
            </div>
            {/*             <div>
                <img className="animate-5" src={furnatura} style={{ margin: "35px", maxWidth: "300px" }} alt="Furnatura" />
                <h4 className="line project animate-6">Natural cosmetic products for dogs</h4>
                <p className="animate-7">The key to a healthy dog coat</p>
                <a className="animate-8" href="https://www.furnatura.com/" target="_blank" rel="noopener noreferrer">
                    Navštivte web
                </a>
            </div> */}
            <div>
                <img className="animate-5" src={yogarden} style={{ margin: "15px", maxWidth: "130px" }} alt="Mondelez" />
                <h4 className="line project animate-6" style={{ color: "#3c4f51" }}>
                    Místo pro váš aktivní odpočinek
                </h4>
                <p className="animate-7">Yogarden je pomyslná zahrada pro váš vědomý odpočinek. Naše tři sály skýtají dostatek prostoru k pohybu i nadechnutí.</p>
                <a className="animate-8" href="https://www.yogarden.cz" target="_blank" rel="noopener noreferrer">
                    Přijďte se vyzenovat
                </a>
            </div>
        </div>
    </article>
);

const Others = ({ indx, setObserverRef }) => (
    <article className="article" id="experience" ref={setObserverRef} data-observer={indx}>
        <div className="text">
            {/* <h2 className="line animate-1">Vážíme si každé spolupráce</h2> */}
            <h2 className="line animate-1">Důvěřují nám velké firmy</h2>
            <p className="animate-2">I to nám dává motivaci v dalších projektech. </p>
        </div>
        <div id="bigClients" className="animate-3">
            <Logos />
        </div>
        <div className="clear"></div>
        <div className="text animate-4" style={{ position: "relative", zIndex: 500 }}>
            <br />
            <p>
                <Link to="/cz/jak-pracujeme/">Zjistěte víc o tom, jak pracujeme</Link>
            </p>
        </div>
    </article>
);

const sections = [Ecommerce, Architects, Hospitality, Publishing, MobileApps, Collections, ThereSMore, Others];

const Projects = () => {
    const { setRef } = useIsInViewport();
    return (
        <>
            <Seo title="Reference" />
            <div>
                {sections.map((Component, index) => (
                    <Component key={index} indx={index} setObserverRef={setRef} />
                ))}
            </div>
            <div className="clear"></div>
        </>
    );
};
export default Projects;
